import React from 'react';

import './MerinoWool.scss';

import feather1 from '../../static/images/merinowool/feather-1.png';
import feather2 from '../../static/images/merinowool/feather-2.png';
import feather3 from '../../static/images/merinowool/feather-3.png';

import redShoe from '../../static/images/merinowool/shoe-red.png';
import grayShoe from '../../static/images/merinowool/shoe-gray.png';
import brownShoe from '../../static/images/merinowool/shoe-brown.png';
import purpleShoe from '../../static/images/merinowool/shoe-purple.png';
import blueShoe from '../../static/images/merinowool/shoe-blue.png';
import blackBShoe from '../../static/images/merinowool/shoe-black-b.png';
import yellowShoe from '../../static/images/merinowool/shoe-yellow.png';
import blackWShoe from '../../static/images/merinowool/shoe-black-w.png';
import greenShoe from '../../static/images/merinowool/shoe-green.png';

import staticBannerImage from './../../static/images/merinowool/banner.jpg';
import staticBannerImageMobile from './../../static/images/merinowool/banner-sm.jpg';

import staticBgSec3 from './../../static/images/merinowool/bg-sec3.jpg';
import staticBgSec3Mobile from './../../static/images/merinowool/bg-sec3-sm.jpg';
import staticBgSec4 from './../../static/images/merinowool/bg-sec4.jpg';
import staticBgSec4Mobile from './../../static/images/merinowool/bg-sec4-sm.jpg';

import staticBgSec5Mobile from './../../static/images/merinowool/bg-sec5-sm-2.jpg';
import staticBgSec5 from './../../static/images/merinowool/bg-sec5-2.jpg';
import staticBgSec5Uhd from './../../static/images/merinowool/bg-sec5-3.jpg';

import staticShoeLayer1 from './../../static/images/merinowool/shoe-layers-1.png';
import staticShoeLayer2 from './../../static/images/merinowool/shoe-layers-2.png';
import staticShoeLayer3 from './../../static/images/merinowool/shoe-layers-3.png';
import staticShoeLayer4 from './../../static/images/merinowool/shoe-layers-4.png';

import shoeModelImageStatic from './../../static/images/merinowool/shoe-with-model.jpg';

const MerinoWool1 = (props) => {
  
  const {
    bannerText,
    bannerSmallText,
    bannerImage,
    bannerImageMobile,
    bannerPrice,
    bannerButton1Text,
    bannerButton2Text,
    bannerButton1Url,
    bannerButton2Url,

    shoeLayersText,
    shoeLayer1,
    shoeLayer2,
    shoeLayer3,
    shoeLayer4,

    sec3Text,
    sec3Button1Text,
    sec3Button2Text,
    sec3Button1Url,
    sec3Button2Url,

    sec4Text,

    sec5Text,

    shoeModelImage,

    bgSec3,
    bgSec3Mobile,
    bgSec4,
    bgSec4Mobile,
    bgSec5,
    bgSec5Mobile,
    bgSec5Uhd,
  } = props;

  return (
    <div className="landingpage-merinowool">
      <style>
      {`
        .banner {
          background: #edf0f5 url(${bannerImageMobile}) no-repeat 50% 0;
        }

        @media (min-width: 568px) {
          .banner{
            background-image:url(${bannerImage});
          }
        }
      `}
      </style>

      <section className="banner">
        <div className="container">
          <article className="content clearfix mb-4">
            {bannerText}
            <p className="quality">{bannerSmallText}</p>
          </article>
        </div>
        <div className="cta">
          <div className="container px-0 px-md-3">
            <p className="d-none d-md-block h2 price pb-3">{bannerPrice}</p>
            <div className="row compact btn-cont">
              <div className="col-6"><a href={bannerButton1Url} className="btn btn-dark btn-block mb-3">{bannerButton1Text}</a></div>
              <div className="col-6"><a href={bannerButton2Url} className="btn btn-dark  btn-block mb-3">{bannerButton2Text}</a></div>
            </div>
          </div>
        </div>
      </section>
      <section className="sec2 py-0 featured text-center d-none d-xl-block">
        <div className="container-fluid">
          <div className="row">
            <figure className="col-12 col-xl shoe"><p className="bg-light"><img src={redShoe} alt="" /></p></figure>
            <figure className="col-12 col-xl shoe"><p className="bg-light"><img src={grayShoe} alt="" /></p></figure>
            <figure className="col-12 col-xl shoe"><p className="bg-light"><img src={brownShoe} alt="" /></p></figure>
            <figure className="col-12 col-xl shoe"><p className="bg-light"><img src={purpleShoe} alt="" /></p></figure>
            <figure className="col-12 col-xl shoe"><p className="bg-light"><img src={blueShoe} alt="" /></p></figure>
            <figure className="col-12 col-xl shoe"><p className="bg-light"><img src={blackBShoe} alt="" /></p></figure>
            <figure className="col-12 col-xl shoe"><p className="bg-light"><img src={yellowShoe} alt="" /></p></figure>
            <figure className="col-12 col-xl shoe"><p className="bg-light"><img src={blackWShoe} alt="" /></p></figure>
            <figure className="col-12 col-xl shoe"><p className="bg-light"><img src={greenShoe} alt="" /></p></figure>
          </div>
        </div>
      </section>
      <section className="sec sec7 pb-xl-5">
        <div className="container">
          <div className="row">
            <article className="content col-12 col-md-12 col-lg-7 col-xl-6 mb-5 mb-lg-0">
              {shoeLayersText}
            </article>
            <div className="col-12 col-md-12 col-lg-5 col-xl-6">
              {/*<p><img src="images/shoe-layers.png" alt="" /></p>*/}
              <div id="slipper-animation">
                <div id="animationWrapper" className="clearfix">
                  <div id="slipper-animation-container" className="float-lg-right">
                    <figure id="AnimationContainer" className="animation-container">
                      <picture id="layer-top">
                        <source srcSet={shoeLayer1} />
                        <img src={shoeLayer1} alt="" id="layer-top-img" />
                      </picture>									
                      <picture id="layer-inside" style={{transform: 'translateY(136.957px)'}}>
                        <source srcSet={shoeLayer2} />
                        <img src={shoeLayer2} alt="" id="layer-inside-img" />
                      </picture>
                      <picture id="layer-bottom" style={{transform: 'translateY(196.875px)'}}>
                        <source srcSet={shoeLayer3} />
                        <img src={shoeLayer3} alt="" id="layer-bottom-img" />
                      </picture>
                      <picture id="layer-base" style={{transform: 'translateY(242.308px)'}}>
                        <source srcSet={shoeLayer4} />
                        <img src={shoeLayer4} alt="" id="layer-insole-img" />
                      </picture>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>
        {`
          .sec3 {
            background:url(${bgSec3Mobile});
          }

          @media (min-width: 768px) {
            .sec3 {
              background-image: url(${bgSec3});
            }
          }
        `}
      </style>

      <section className="sec sec3">
        <div className="container">
          <div className="row">
            <article className="content col-11 col-sm-9 col-md-7 col-lg-5 col-xl-5">
              {sec3Text}
              <p className="mt-5 ">
                <a href={sec3Button1Url} className="btn btn-outline-light mb-3 mr-3">{sec3Button1Text}</a>
                <a href={sec3Button2Url} className="btn btn-outline-light  mb-3">{sec3Button2Text}</a>
              </p>
            </article>
          </div>
        </div>
      </section>
      
      <style>
        {`
          .sec4 {
            background:url(${bgSec4Mobile});
          }

          @media (min-width: 992px) {
            .sec4 {
              background-image: url(${bgSec4});
            }
          }
        `}
      </style>

      <section className="p-3 p-md-4 p-lg-5">
        <div className="container-fluid sec sec4 p-4 p-sm-5 p-lg-5 ">
          <div className="row  mt-xl-5 pt-xl-5">
            <article className="content col-10 col-sm-6 col-md-5 col-lg-5 col-xl-4  pt-5 pb-lg-4   mt-md-5 pl-lg-5 ">
              {sec4Text}
            </article>
          </div>
        </div>
      </section>

      <style>
        {`
          .sec5 {
            background-image: url(${bgSec5Mobile});
          }

          @media (min-width: 768px) {
            .sec5 {
              background-image: url(${bgSec5});
            }
          }

          @media (min-width: 1921px) {
            .sec5 {
              background-image: url(${bgSec5Uhd});
            }
          }
        `}
      </style>

      <section className="sec sec5">
        <div className="container">
          <div className="row">
            <article className="content col-11 col-md-4 col-lg-4 col-xl-4">
              {sec5Text}
            </article>
            <figure className="col-12 col-md-8 feathers">
              <img src={feather1} alt="alt" className="feather-1 hide animated" />
              <img src={feather2} alt="alt" className="feather-2 hide animated delay-1" />
              <img src={feather3} alt="alt" className="feather-3 hide animated delay-2" />
            </figure>
          </div>
        </div>
      </section>
      <section className="sec sec6 p-0 text-center sec-model">
        <p className="m-0"><img src={shoeModelImage} alt="" className="full" /></p>
      </section>
    </div>
  );
}

MerinoWool1.defaultProps = {
  bannerText: <>
    <h1><strong>MERINO</strong> <br /> WOOL <br /> KNIT</h1>
  </>,
  bannerSmallText: '100% merino wool',
  bannerImage: staticBannerImage,
  bannerImageMobile: staticBannerImageMobile,
  bannerPrice: '139€',
  bannerButton1Text: 'WOMEN',
  bannerButton2Text: 'MEN',
  bannerButton1Url: '#',
  bannerButton2Url: '#',

  shoeLayersText: <>
    <h2><strong>Discover <br /> Merino wool</strong> <br /> layers of comfort</h2>
    <p>Light, breezy feet with our Merino Wool Knit! With a total weight of about 550 grams (19 ounces) this shoe guarantees feather-light comfort all year round.</p>
    <ul className="bullet">
      <li>100% Merino Wool Knit</li>
      <li>100% Merino Wool Stretch Lining</li>
      <li>Extra Light Merino Wool Footbed</li>
      <li>Durable and light EVA sole</li>
    </ul>
  </>,
  shoeLayer1: staticShoeLayer1,
  shoeLayer2: staticShoeLayer2,
  shoeLayer3: staticShoeLayer3,
  shoeLayer4: staticShoeLayer4,

  sec3Text: <>
    <h2>MERINO WOOL. <br /> <strong>REINVENTED.</strong></h2>
    <p>Are you a fan of our Merino Runners? If, you’ve already experienced our shoes’ incredible comfort. In our new Merino Wool Knit, we unite our “tried and true” comfort with a whole new layer: our Merino 3D Knit look. Proven comfort redefined!</p>
  </>,
  sec3Button1Text: 'WOMEN',
  sec3Button2Text: 'MEN',
  sec3Button1Url: '#',
  sec3Button2Url: '#',

  sec4Text: <>
    <h2>Socks <br /> are so <br /> <strong>Yesterday.</strong></h2>
    <p>Slip your bare feet into our soft Merino Wool Knit—made of 100% cozy Merino Wool. We promise that you’ll never want to take them off again…socks are so yesterday!</p>
  </>,

  sec5Text: <>
    <h2>FEATHER <br className="d-none d-lg-block" /> <strong>LIGHT</strong></h2>
    <p>Light, breezy feet with our Merino Wool Knit! With a total weight of about 550 grams (19 ounces) this shoe guarantees feather-light comfort all year round.</p>
  </>,

  shoeModelImage: shoeModelImageStatic,

  bgSec3: staticBgSec3,
  bgSec3Mobile: staticBgSec3Mobile,
  bgSec4: staticBgSec4,
  bgSec4Mobile: staticBgSec4Mobile,

  bgSec5Mobile: staticBgSec5Mobile,
  bgSec5: staticBgSec5,
  bgSec5Uhd: staticBgSec5Uhd,
}

export default  MerinoWool1;